export default __webpack_public_path__ + "static/media/etranslator-screenshot-03.1d7bde54.png";